<template>
    <div>
        <v-form data-vv-scope="requestForm">
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title style="padding-left: 0px">
                        Phiếu nhập lại kho sau sửa chữa
                    </v-toolbar-title>
                </v-toolbar>
                <v-btn
                    @click="close"
                    icon
                    style="position: absolute; right: 10px; top: 10px; color: #fff"
                >
                    <v-icon>cancel</v-icon>
                </v-btn>
                <v-card-text>
                    <v-layout wrap style="padding: 10px;">
                        <v-flex xs12 sm12 md6 style="padding: 10px">
                            <p class="font-weight-bold">
                                Số phiếu:
                                {{ createItem.importRepairCode }}
                            </p>
                            <p class="font-weight-bold">
                                Số đề nghị sửa chữa:
                                {{ createItem.repairRequestCode }}
                            </p>
                            <p class="font-weight-bold">
                                Ngày nhập kho:
                                {{ createItem.importDate }}
                            </p>
                            <p class="font-weight-bold">
                                Bộ phận sử dụng hiện tại:
                                {{ departmentName }}
                            </p>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            <p class="font-weight-bold">
                                Tên tài sản:
                                {{ fixedAssetsName }}
                            </p>
                            <p class="font-weight-bold">
                                Địa điểm sử dụng hiện tại:
                                {{ locationName }}
                            </p>
                            <p class="font-weight-bold">
                                Tình trạng sau sửa chữa gần nhất:
                                
                            </p>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text>
                    <table class="lstTable">
                        <tr>
                            <th width="20%">Đơn vị sửa chữa</th>
                            <th width="20%">Nội dung sửa chữa</th>
                            <th width="20%">Tình trạng sau sửa chữa</th>
                            <th>Ghi chú</th>
                            <th width="10%" v-if="showPrice">Chi phí sửa chữa</th>
                            <th width="10%" v-if="showPrice">Bảo hành sửa chữa</th>
                        </tr>
                        <tr>
                            <td style="text-align:center">
                                {{ this.repairUnitName }}
                            </td>
                            <td style="text-align:center">
                                {{ this.createItem.repairContent }}
                            </td>
                            <td style="text-align:center">
                                <v-text-field
                                    type="text"
                                    v-model.trim="createItem.conditionAfterRepair"
                                    maxLength="250"
                                    v-if="showAccept1"
                                ></v-text-field>
                                <template v-else>{{ createItem.conditionAfterRepair }}</template>
                            </td>
                            <td style="text-align:center">
                                <v-text-field
                                    type="text"
                                    v-model.trim="createItem.note"
                                    maxLength="250"
                                    v-if="showAccept1"
                                ></v-text-field>
                                <template v-else>{{ createItem.note }}</template>
                            </td>
                            <td v-if="showPrice" style="text-align:center">
                                <v-text-field
                                    v-if="showAccept2"
                                    type="number"
                                    label="Chi phí sửa chữa"
                                    v-model.trim="createItem.repairCost"
                                    name="repairCost"
                                ></v-text-field>
                                <template v-else>{{ createItem.repairCost | currency}}</template>
                            </td>
                            <td v-if="showPrice" style="text-align:center">
                                <i-datepicker 
                                    v-if="showAccept2"
                                    v-model="createItem.repairWarranty"
                                />
                                <template v-else>{{ formatDate(createItem.repairWarranty) }}</template>
                            </td>
                        </tr>
                    </table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="showAccept1" color="primary" @click="onAccept(1)" :disabled="loading">
                        {{ $t("lang.common.confirm") }}
                    </v-btn>
                    <v-btn v-if="showAccept2" color="primary" @click="onAccept(2)" :disabled="loading">
                        {{ $t("lang.common.confirm") }}
                    </v-btn>
                    <v-btn v-if="showApprove" color="success" @click="onApprove" :disabled="loading">
                        {{ $t("Phê duyệt") }}
                    </v-btn>
                    <v-btn color="warning" @click="close">
                        {{ $t("lang.common.return") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>    
</template>

<script>

import { message } from "../../../services";
import CSearchForm from "../../../components/form/ManageForm";
import axios from "axios";
import moment from "moment";
import {roleConstants, requestConstants} from "@/constants";
import RepairEdit from "./RepairEdit.vue";
import DialogReject from "./component/DialogReject.vue";
import DialogCancel from "./component/DialogCancel.vue";
import DialogDelete from "./component/DialogDelete.vue";

export default {
    name: "import-repair-request-view",
    components: { CSearchForm, RepairEdit, DialogReject, DialogCancel, DialogDelete },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        propsItem: {
            type: Object,
            default: ()=> {}
        },
    },
    data: () => {
        return {
            loading: false,
            lstHistory: [],
            fixedAssetsName: '',
            fixedAssetsCode: '',
            locationName: '',
            departmentName: '',
            lstSupplier: [],
            lstFixedAssets: [],
            repairItem: null,
            repairCreateDialog: false,
            fixedAssetsId: null,
            dialogCancelRequest: false,
            dialogRejectRequest: false,
            dialogDeleteRequest: false,
            historyDlg: false,
            repairUnitName: '',
            createItem: {
                repairRequestCode: '',
                fixedAssetsId: '',
                importDate: '', 
                repairUnitId: '',  
                repairContent: '',
                repairCost: 0,
                status: 1,
                accept1: '',
                accept2: '',
                note: '',
                repairWarranty: '',
            },
        };
    },
    watch: {
        
    },
    created() {
        this.getFixedAssets();
        this.getSupplier();

        let queryParam = this.$route.query;
        if (queryParam.importRepairId != undefined && queryParam.importRepairId > 0) {
            this.getImportRepairById(queryParam.importRepairId);
        }
    },
    computed: {
        showApprove() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                && this.createItem.status == requestConstants.importRepairRequestStatusCons.waitApprove) {
                return true;
            } else {
                return false;
            }
        },
        showReject() {
            // return true;
            if (this.createItem.status == undefined) return false;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                && this.createItem.status == requestConstants.repairRequestStatusCons.waitApprove) {
                return true;
            } else {
                return false;
            }
        },
        showExport () {
            // return true;
            if (this.createItem.status == undefined) return false;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER
                && this.createItem.status == requestConstants.repairRequestStatusCons.approved) {
                return true;
            } else {
                return false;
            }
        },
        showImport () {
            // return true;
            if (this.createItem.status == undefined) return false;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER
                && this.createItem.status == requestConstants.repairRequestStatusCons.exported) {
                return true;
            } else {
                return false;
            }
        },
        showCreateImport() {
            if (this.createItem.status == undefined) return false;
            if (this.createItem.userCreateId != null) {
                if (this.createItem.status == requestConstants.repairRequestStatusCons.exported
                    && this.$store.state.auth.user.userId == this.createItem.userCreateId) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (this.createItem.status == requestConstants.repairRequestStatusCons.exported) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        showUpdate() {
            // return true;
            if (this.createItem.status == undefined) return false;
            if (this.createItem.userCreateId != null) {
                if ((this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                    || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                    || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT)
                    && (this.createItem.status == requestConstants.repairRequestStatusCons.waitApprove
                    || this.createItem.status == requestConstants.repairRequestStatusCons.approved
                    || this.createItem.status == requestConstants.repairRequestStatusCons.exported)
                    && this.$store.state.auth.user.userId == this.createItem.userCreateId) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if ((this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                    || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                    || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT)
                    && this.createItem.status == requestConstants.repairRequestStatusCons.waitApprove) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        showDelete() {
            // return true;
            if (this.createItem.status == undefined) return false;
            if ((this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT)
                && this.createItem.status == requestConstants.repairRequestStatusCons.waitApprove
                && this.$store.state.auth.user.userId == this.createItem.userCreateId) {
                return true;
            } else {
                return false;
            }
        },
        showCancel() {
            // return true;
            if (this.createItem.status == undefined) return false;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                && this.createItem.status == requestConstants.repairRequestStatusCons.approved) {
                return true;
            } else {
                return false;
            }
        },
        showAccept1() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER 
                && this.createItem.status != requestConstants.importRepairRequestStatusCons.approved) {
                return true;
            } else {
                return false;
            }
        },
        showAccept2() {
            if ((this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT) 
                && this.createItem.status != requestConstants.importRepairRequestStatusCons.approved) {
                return true;
            } else {
                return false;
            }
        },
        showPrice() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ADMIN) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        onApprove() {
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/importRepairRequest/updateStatus", 
                {importRepairId: this.createItem.importRepairId, status: requestConstants.importRepairRequestStatusCons.approved})
                .then(
                    (data) => {
                        if (data) {
                            message.success(this.$t("lang.common.save_success"));
                            this.close();
                        } else {
                            message.error(this.$t("lang.common.save_error"));
                        }
                    }
                );
        },
        onAccept(type) {
            let updateItem = {};
            if (type == 1) {
                updateItem = {
                    importRepairId: this.createItem.importRepairId,
                    accept1: 1,
                    conditionAfterRepair: this.createItem.conditionAfterRepair,
                    note: this.createItem.note,
                    status: 2,
                };
            } else {
                updateItem = {
                    importRepairId: this.createItem.importRepairId,
                    accept2: 1,
                    repairCost: this.createItem.repairCost,
                    repairWarranty: this.createItem.repairWarranty,
                    status: 2,
                };
            }
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/importRepairRequest/updateStatus", updateItem)
                .then(
                    (data) => {
                        if (data) {
                            message.success(this.$t("lang.common.save_success"));
                            this.close();
                        } else {
                            message.error(this.$t("lang.common.save_error"));
                        }
                        this.loading = false;
                    }
                );
        },
        close(fixedAssetsId = null) {
            const query = this.$route.query;
            delete query.importRepairId;
            this.$router.push({ path: `/fixedAssetsRepair`, query: query });
        },
        getHistory(repairRequestId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/repairRequest/searchHistory?repairRequestId=" + repairRequestId).then(
                (data) => {
                    this.lstHistory = data;
                }
            );
        },
        getFixedAssetsById(fixedAssetsId) {
            axios.post(process.env.VUE_APP_API_URL + "/fixedAssets/detailReport?pageSize=-1&page=-1", {fixedAssetsId: fixedAssetsId})
            .then(
                (data) => {
                    if (data.items != undefined && data.items.length > 0) {
                        const item = data.items[0];
                        this.fixedAssetsName = item.name;
                        this.fixedAssetsCode = item.code;
                        this.locationName = item.locationName;
                        this.departmentName = item.departmentName;
                        
                        if (this.createItem.repairRequestId == undefined && item.supplierId != null && item.supplierId.length > 0) {
                            const supplierIdArray = item.supplierId.split(",");
                            this.createItem.repairUnitId = parseInt(supplierIdArray[0]);
                        }
                    }
                }
            );
        },
        minDate() {
            const minDate = moment().format('YYYY-MM-DD');
            return minDate;
        },
        getSupplier() {
            axios.post(
                process.env.VUE_APP_API_URL + "/partner/search?pageSize=-1&page=-1&orderBy=asc",
                 {typeId: 340}
            )
                .then(
                    (data) => {
                        if (data.items) {
                            this.lstSupplier = data.items;
                            if (this.repairUnitName == '') {
                                this.getSupplierName(this.createItem.repairUnitId);
                            }
                        }
                    }
                );
        },
        getSupplierName(supplierId) {
            const partner = this.lstSupplier.find((v) => v.partnerId === supplierId);
            if (partner != undefined) {
                this.repairUnitName = partner.partnerName;
            }
        },
        getFixedAssets() {
            axios.post(process.env.VUE_APP_API_URL + "/fixedAssets/detailReport?pageSize=-1&page=-1&isFixing=0", {})
            .then(
                (data) => {
                    if (data.items != undefined && data.items.length > 0) {
                        this.lstFixedAssets = data.items;
                    }
                }
            );
        },
        getImportRepairById(importRepairId) {
            axios.post(process.env.VUE_APP_API_URL + "/importRepairRequest/search?pageSize=-1&page=-1", {importRepairId: importRepairId})
            .then(
                (data) => {
                    if (data.items != undefined && data.items.length > 0) {
                        this.createItem = data.items[0];

                        if (this.createItem.importDate != '' && this.createItem.importDate != null) {
                            this.createItem.importDate = moment(String(this.createItem.importDate)).format('DD-MM-YYYY')
                        }

                        this.getSupplierName(this.createItem.repairUnitId);
                        this.getFixedAssetsById(this.createItem.fixedAssetsId);
                    }
                }
            );
        },
        formatDate(date) {
            return moment(String(date)).format('DD-MM-YYYY');
        }
    },
    destroyed() {},
};
</script>
